import { menuPrefixCls } from "@/base/components/index";
import { createStyles } from "antd-style";

export const useHeaderNavigateStyles = createStyles(({ token, css }: any) => ({
  signin: css``,
  signinButton: css`
    min-width: 120px;
  `,
  menu: css``,
  menuItemAccount: css`
    .${menuPrefixCls}-item-icon, .${menuPrefixCls}-title-content {
      color: ${token.ColorFigmaNeutralWhiteWhite100} !important;
    }
  `,
  menuItemDivider: css`
    display: flex !important;
    align-items: center !important;
    padding: 0 !important;
    height: 32px !important;
    line-height: 32px !important;
    cursor: default !important;

    .${menuPrefixCls}-title-content {
      flex: 1;
    }
  `,
  menuItemDividerCmp: css`
    margin: 0 !important;

    border-color: ${token.ColorFigmaNeutralWhiteWhite100} !important;
    color: ${token.ColorFigmaNeutralWhiteWhite100} !important;
  `,
  menuComponent: css`
    display: flex;
    justify-content: flex-end;
    .${menuPrefixCls}-submenu-title {
      display: flex;
      flex-direction: column;
      min-height: 64px;
      align-items: center;
      justify-content: center;
    }
  `,
  userMenu: css`
    .cso-portal-menu-title-content {
      margin-inline-start: 0px !important;
    }
  `,
  cartIcon: css`
    color: ${token.ColorFigmaNeutralWhiteWhite100};
    vertical-align: -0.25em;
  `,
  buttonMenu: css`
    vertical-align: -0.3em;
    cursor: pointer;
  `,
}));
